export default theme => ({
  container: {
    marginTop: theme.spacing(4),
    flexDirection: 'column',
    padding: '0 10%',
    [theme.breakpoints.down('lg')]: {
      padding: '0 5%'
    }
  },
  box: {
    marginBottom: '2%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    flex: 1
  },
  table: {
    border: '1px solid ' + theme.palette.divider,
    overflow: 'hidden',
    '& .MuiTableCell-footer': {
      border: 'none'
    }
  },
  headerRow: {
    cursor: 'pointer',
    backgroundColor: '#f3f3f3'
  },
  row: {
    backgroundColor: '#f3f3f3',
    '&:hover': {
      backgroundColor: theme.overrides.MuiSelected.root['&:hover'].backgroundColor + '!important',
      '& th': {
        color: theme.palette.text.primary
      }
    }
  },
  oddRow: {
    backgroundColor: theme.palette.primary.main
  },
  tableText: {
    fontSize: '0.7rem'
  },
  tableHeader: {
    fontSize: '0.7rem',
    color: theme.palette.text.secondary,
    fontWeight: 'bold'
  },
  drawerPaper: {
    width: 550,
    zIndex: 1300
  },
  drawerRoot: {
    width: 0 // to allow click on the background
  },
  icon: {
    '& div': {
      display: 'flex',
      width: theme.spacing(5),
      height: theme.spacing(5),
      alignItems: 'center'
    }
  },
  header: {
    height: '4rem',
    backgroundColor: theme.palette.secondary.main
  },
  fieldset: {
    '&:hover': {
      borderColor: theme.palette.text.primary
    }
  }
});
